"use client"

import { formatDayLabel } from "@/lib/conversation/time-format"

/**
 * Sticks to the top of the thread's own scroll container, so a long day never
 * leaves the reader guessing which one they are in.
 */
export function ConversationDateSeparator({
  date,
  timezone,
}: {
  date: string
  timezone: string
}) {
  return (
    // A floating chip, not a full-width band: the band's edge cut messages in half
    // as they scrolled under it. The strip stays click-through — it covers the top
    // of the thread, where links and media are still live.
    <div className="pointer-events-none sticky top-0 z-10 flex justify-center py-2">
      <span className="pointer-events-auto rounded-full border bg-background px-2.5 py-0.5 text-[11px] text-muted-foreground shadow-sm">
        {formatDayLabel(date, timezone)}
      </span>
    </div>
  )
}
